(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ar-logo-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ar-logo-motion')) {
    customElements.define('ar-logo-motion', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas.getContext('2d', { willReadFrequently: true });
        this.frameCallback = null;
        this.animationCallback = null;
        this.toggle = this.querySelector('button');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.visible = false;
        this.loaded = false;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.update = () => {
          if (this.motion.matches) {
            this.video.pause();
            this.classList.remove('is-ready');
            this.toggle.hidden = true;
            return;
          }
          if (!this.loaded || !this.visible || document.hidden || this.userPaused) {
            this.video.pause();
            return;
          }
          const source = this.video.querySelector('source');
          if (!source.hasAttribute('src')) {
            source.src = source.dataset.src;
            this.video.load();
          }
          this.video.muted = true;
          this.video.play().catch(() => {});
        };
        this.video.addEventListener('playing', () => {
          if (!this.motion.matches) this.renderFrame();
        }, options);
        this.video.addEventListener('error', () => {
          this.classList.remove('is-ready');
          this.toggle.hidden = true;
        }, options);
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.classList.toggle('is-paused', this.userPaused);
          this.toggle.setAttribute('aria-pressed', String(this.userPaused));
          this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.resume : this.toggle.dataset.pause);
          this.update();
        }, options);
        this.motion.addEventListener('change', this.update, options);
        document.addEventListener('visibilitychange', this.update, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
        const start = () => {
          this.timer = setTimeout(() => { this.loaded = true; this.update(); }, 1000);
        };
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true, signal: this.controller.signal });
      }
      renderFrame() {
        if (!this.isConnected || this.motion.matches || this.video.paused || !this.context) return;
        const width = this.canvas.width;
        const height = this.canvas.height;
        try {
          this.context.drawImage(this.video, 0, 0, width, height);
          const frame = this.context.getImageData(0, 0, width, height);
          const pixels = frame.data;
          for (let x = 0; x < width; x++) {
            const top = [0, 0, 0];
            const bottom = [0, 0, 0];
            for (let sample = 2; sample < 6; sample++) {
              const topIndex = (sample * width + x) * 4;
              const bottomIndex = ((height - 1 - sample) * width + x) * 4;
              for (let channel = 0; channel < 3; channel++) {
                top[channel] += pixels[topIndex + channel] / 4;
                bottom[channel] += pixels[bottomIndex + channel] / 4;
              }
            }
            const background = [0, 0, 0];
            for (let y = 0; y < height; y++) {
              const index = (y * width + x) * 4;
              const position = Math.max(0, Math.min(1, (y - 3.5) / (height - 8)));
              let distanceSquared = 0;
              for (let channel = 0; channel < 3; channel++) {
                background[channel] = top[channel] * (1 - position) + bottom[channel] * position;
                const difference = pixels[index + channel] - background[channel];
                distanceSquared += difference * difference;
              }
              const edge = Math.max(0, Math.min(1, (Math.sqrt(distanceSquared) - 8) / 16));
              const alpha = edge * edge * (3 - 2 * edge);
              pixels[index + 3] = Math.round(alpha * 255);
              if (alpha > 0 && alpha < 1) {
                for (let channel = 0; channel < 3; channel++) {
                  pixels[index + channel] = Math.max(0, Math.min(255,
                    (pixels[index + channel] - (1 - alpha) * background[channel]) / alpha));
                }
              }
            }
          }
          this.context.putImageData(frame, 0, 0);
          this.classList.add('is-ready');
          this.toggle.hidden = false;
        } catch {
          this.classList.remove('is-ready');
          this.toggle.hidden = true;
          this.video.pause();
          return;
        }
        if (this.frameCallback !== null || this.animationCallback !== null) return;
        if ('requestVideoFrameCallback' in this.video) {
          this.frameCallback = this.video.requestVideoFrameCallback(() => {
            this.frameCallback = null;
            this.renderFrame();
          });
        } else {
          this.animationCallback = requestAnimationFrame(() => {
            this.animationCallback = null;
            this.renderFrame();
          });
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.frameCallback !== null) this.video.cancelVideoFrameCallback(this.frameCallback);
        if (this.animationCallback !== null) cancelAnimationFrame(this.animationCallback);
        this.controller.abort();
        this.observer.disconnect();
        this.video.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
